import styled, { css } from "styled-components"

export const ErrorMessage = styled.span`
  ${({ theme }) => {
    const { colors, spaces } = theme
    const { size, weight, lineHeight } = theme.fonts

    return css`
      display: flex;
      align-items: center;
      gap: ${spaces.xxs};
      color: ${colors.danger.bg};
      font-size: ${size.smallParagraph};
      line-height: ${lineHeight.oneAndHalf};
      font-weight: ${weight.regular};
    `
  }}
`

/**
 * Container to place error message under form fields
 **/
export const ErrorMessageContainer = styled.div`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      display: flex;
      align-items: center;
      gap: ${spaces.extraSmall};
      margin-top: ${spaces.extraSmall};
    `
  }}
`
